import { Component } from 'react';

class SwallowErrors extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }

}

export { SwallowErrors };
